import enterpriseAnim from './enterprise-anim.json';

export { enterpriseAnim };
